import { useMemo, useEffect, useState } from 'react'

import MuiStack from '@mui/material/Stack'
import MuiIconButton from '@mui/material/IconButton'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { DataGridPro as DataGrid } from '@mui/x-data-grid-pro'
import { LicenseInfo } from '@mui/x-license-pro'

import { useGetFieldsQuery } from '../../../../../services/fields/slice'
import AppConfig from '../../../../../config'
import RemoveProducer from './removeProducer'
import { useGetClientQuery } from '../../../../clients/slice'

LicenseInfo.setLicenseKey(AppConfig.mui.licenseKey)

const ProducerList = ({ campaign }) => {
  const { data: client, isLoading: isClientLoading } = useGetClientQuery(
    campaign?.client,
    { skip: !campaign?.client }
  )
  const { data: fields, isLoading: isFieldsLoading } =
    useGetFieldsQuery('producers')
  const [rows, setRows] = useState([])
  const [producer, setProducer] = useState()
  const [RemoveDialogOpen, setRemoveDialogOpen] = useState(false)

  useEffect(() => {
    if (campaign && client) {
      const producers = campaign.producers
        .map((producerId) => {
          return client.producers.find((p) => p.id === producerId)
        })
        .filter((p) => p)
      setRows(producers)
    }
  }, [campaign, client])

  const handleRemoveClick = (producer) => {
    setProducer(producer)
    setRemoveDialogOpen(true)
  }

  const columns = useMemo(() => {
    if (campaign && fields) {
      const producer = fields
        .map((field) => {
          const type =
            field.type === 'boolean'
              ? 'boolean'
              : field.type === 'date'
              ? 'date'
              : undefined
          return {
            field: field.name,
            headerName: field.label,
            description: field.description,
            width: field.width || 200,
            editable: false,
            type,
            priority: field.priority || 999999,
          }
        })
        .sort((a, b) => a.priority - b.priority)
      return [
        ...producer,
        {
          field: 'actions',
          headerName: 'Action',
          flex: 1,
          sortable: false,
          // disableClickEventBubbling: true,

          renderCell: (params) => {
            const onRemoveClick = (e) => {
              const currentRow = params.row
              handleRemoveClick(currentRow)
            }

            return (
              <MuiStack direction="row">
                <MuiIconButton size="small" onClick={onRemoveClick}>
                  <RemoveCircleOutlineIcon />
                </MuiIconButton>
              </MuiStack>
            )
          },
        },
      ]
    }
    return []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaign, fields])

  return (
    <>
      <DataGrid
        rows={rows}
        columns={columns}
        density="compact"
        loading={isFieldsLoading || isClientLoading}
        disableRowSelectionOnClick
        hideFooter
        sx={{
          '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
            outline: 'none !important',
          },
          '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus':
            {
              outline: 'none !important',
            },
        }}
      />
      <RemoveProducer
        campaign={campaign}
        producer={producer}
        open={RemoveDialogOpen}
        setOpen={setRemoveDialogOpen}
      />
    </>
  )
}

export default ProducerList
